import { createUseStyles } from 'react-jss';

export default createUseStyles({
  highValueNotificationContainer: {
    backgroundColor: '#ffcccb',
    fontWeight: 700,
  },
});
